import React from 'react';
import {Box, Checkbox, Stack, Tooltip, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {classNames} from "@helpers/classNames";
import {ISyncItemVoyageTemplate} from "@containers/singleVoyage/voyageTemplates/types";
import {
	formatDaySyncVoyageTemplate,
	formatTimeSyncVoyageTemplate
} from "@containers/singleVoyage/voyageTemplates/sync/helpers/format";
import {TONE_SYNC_OUTCOME} from "@containers/singleVoyage/voyageTemplates/sync/constants";
import {sx} from './sx'

interface IProps {
	item: ISyncItemVoyageTemplate
	/** set once sync ran; replaces the preview outcome */
	result?: ISyncItemVoyageTemplate
	checked: boolean
	selectable: boolean
	active: boolean
	onToggle: () => void
	onSelect: () => void
}

const CardSyncVoyageTemplate = ({item, result, checked, selectable, active, onToggle, onSelect}: IProps) => {

	const {t} = useTranslation()

	const outcome = result?.outcome ?? item.outcome
	const reason = result?.reason ?? item.reason
	const timeChanged = item.changes.some((change) => change.type === 'TIME')

	// the validator's own wording only helps for INVALID; the other outcomes say it in their label
	const hint = outcome === 'DIVERGED'
		? t('singleVoyage.voyageTemplate.sync.divergedHint', {
			date: item.updatedDateTime ? formatDaySyncVoyageTemplate(item.updatedDateTime) : '—'
		})
		: outcome === 'INVALID' ? reason : null

	return (
		<Box
			sx={sx.root}
			className={classNames(active && 'active')}
			onClick={onSelect}
		>
			<Checkbox
				size={'small'}
				sx={sx.checkbox}
				checked={checked}
				disabled={!selectable || !!result}
				onClick={(event) => event.stopPropagation()}
				onChange={onToggle}
			/>

			<Stack sx={sx.body}>
				<Stack sx={sx.line}>
					<Typography sx={sx.day}>
						{formatDaySyncVoyageTemplate(item.plannedStart)}
					</Typography>

					<Typography sx={sx.time}>
						{timeChanged
							? `${formatTimeSyncVoyageTemplate(item.plannedStart)} → ${formatTimeSyncVoyageTemplate(item.newPlannedStart)}`
							: formatTimeSyncVoyageTemplate(item.plannedStart)}
					</Typography>
				</Stack>

				<Typography sx={sx.plate}>
					{item.licensePlate ?? '—'}
				</Typography>

				<Tooltip title={hint ?? ''} disableHoverListener={!hint} placement={'right'}>
					<Box sx={[sx.status, sx[TONE_SYNC_OUTCOME[outcome]]]}>
						<Box sx={sx.dot}/>
						{t(`singleVoyage.voyageTemplate.sync.outcome.${outcome}`)}
					</Box>
				</Tooltip>
			</Stack>
		</Box>
	);
};

export default CardSyncVoyageTemplate;
